import { useState, useContext } from "react";
import {
    Box,
    Grid,
    Table,
    TableRow,
    TableCell,
    TableBody,
    TableHead,
    Typography,
    TableContainer,
    Stack,
    FormControl
} from "@mui/material";

//Srcs
import "../../Style/pagestyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import useGetQuestionAndAnswerPagination from "../../Hooks/useGetQuestionAndAnswerPagination";
import { useGetPublicForumById } from "../../Hooks/useGetPublicForumById"
import { ButtonCreate, SearchTextField } from "../../Utils/Component";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import useWithDimension from "../../Hooks/useWithDimension";
import QuestionAndAnswerForm from "../../Components/QuestionAndAnswerPublicForum/QuestionAndAnswerForm";
import QuestoinAndAnswerAction from "../../Components/QuestionAndAnswerPublicForum/QuestoinAndAnswerAction";


export default function QuestionAndAnswer() {
    const { t } = useContext(AuthContext);

    const queryParams = new URLSearchParams(window.location.search);
    const publicForumId = queryParams.get("publicForumId");


    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    const navigate = useNavigate();
    const {
        refetch,
        loading,
        tableData,
        handleSearch,
    } = useGetQuestionAndAnswerPagination(publicForumId);

    const handleNavigate = (id) => {
        navigate(`/secretary-in-mandate/details?id=${id}`);
    };
    // ======================= Resize width Screen ======================
    const { width } = useWithDimension();

    const { publicForumData } = useGetPublicForumById({ id: publicForumId })

    return (
        <div className="page-container">
            <Stack direction="row" alignItems="center" spacing={2}>
                <Box className="slash" />

                <Typography
                    className={t("class-page-title")}
                    onClick={() => navigate("/public-forum")}
                >
                    {t("page_public_forum")}
                </Typography>

                <Typography className={"slash-title"}>/</Typography>

                <Typography className={t("class-page-title")}>
                    {publicForumData?.publicForumTitle} {`(${publicForumData?.districtMunicipalityId?.district_municipality_name_kh || publicForumData?.districtMunicipalityId?.district_municipality_name_en})`}
                </Typography>
            </Stack>
            <Box sx={{marginTop: "20px"}}>
                <Grid container spacing={3}>
                    <Grid item xs={6} sm={6} md={4} lg={3} xl={3}>
                        <Typography className={t("class-name-text-field-title")}>
                            {t("search")}
                        </Typography>
                        <SearchTextField
                            className={"text-field"}
                            handleSearch={handleSearch}
                        />
                    </Grid>


                    <Grid item xs={12} sm={12} md={8} lg={9} xl={9}>
                        <Stack direction="row" justifyContent="flex-end" alignItems="flex-end" height="100%" spacing={1} >

                            <Box>
                                <ButtonCreate
                                    handleOpen={handleOpen}
                                    classBtn={"btn-create"}
                                    classIcon={"icon-add"}
                                />
                            </Box>
                        </Stack>

                        <QuestionAndAnswerForm
                            open={open}
                            publicForumData={publicForumData}
                            handleClose={handleClose}
                            setRefetch={refetch}
                            dialogTitle="Create"
                        />
                    </Grid>
                </Grid>
            </Box>

            <Box className="body-container">
                <TableContainer sx={{ maxWidth: `${width}px` }}>
                    <Table className="table" aria-label="simple table">
                        <TableHead className="header-row ">
                            <TableRow>
                                <TableCell
                                    className={t("class-name-header-title-start")}
                                    width="4%"
                                >
                                    {t("no")}
                                </TableCell>
                                <TableCell className={t("class-name-header-title")} width="21%">
                                    {t("thead_question_or_suggestion")}
                                </TableCell>
                                <TableCell className={t("class-name-header-title")} width="40%">
                                    {t("thead_answer")}
                                </TableCell>
                                <TableCell className={t("class-name-header-title")} width="20%">
                                    {t("thead_work_group")}
                                </TableCell>
                                <TableCell className={t("class-name-header-title")} width="10%">
                                    {t("thead_conclusion")}
                                </TableCell>
                                <TableCell className={t("class-name-header-title-end")} width="10%"></TableCell>
                            </TableRow>
                        </TableHead>
                        {loading ? (
                            <TableBody className="body">
                                <TableRow className="body-row">
                                    <TableCell
                                        colSpan={9}
                                        className="body-cell"
                                        sx={{ bgcolor: "#fff" }}
                                    >
                                        <LoadingPage />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        ) : (
                            <>
                                {tableData?.length === 0 || tableData?.length === undefined ? (
                                    <TableBody className="body">
                                        <TableRow className="body-row">
                                            <TableCell colSpan={9} className="body-cell">
                                                <EmptyData />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                ) : (
                                    <>
                                        <TableBody className="body">
                                            {tableData?.map((row, index) => {
                                                return (
                                                    <TableRow className="body-row" key={index}>
                                                        <TableCell
                                                            className="body-cell-start"
                                                        >
                                                            {index + 1}
                                                        </TableCell>

                                                        <TableCell
                                                            className="body-cell-pre-line"
                                                        >
                                                            <Stack direction={"column"} spacing={1.5}>
                                                                
                                                                <Stack direction={"column"} spacing={0.4}>
                                                                    <Typography>{t('question_type')}: {t(`${row?.questionType}`)}</Typography>
                                                                    <Typography>{t('thead_asker')}: {row?.asker}</Typography>
                                                                    <Typography>{t('thead_commune_sangkat')}: {row?.communeSangkatId?.commune_sangkat_name_kh || row?.communeSangkatId?.commune_sangkat_name_en || ""}</Typography>
                                                                    <Typography>{t('thead_village')}: {row?.villageId?.village_name_kh || row?.villageId?.village_name_en || "" }</Typography>
                                                                </Stack>
                                                                <Typography sx={{lineHeight: '28px'}}>{row?.question}</Typography>
                                                            </Stack>
                                                        </TableCell>

                                                        <TableCell
                                                            className="body-cell-pre-line"
                                                        >
                                                            {row?.answer}
                                                        </TableCell>

                                                        <TableCell
                                                            className="body-cell-pre-line"
                                                        >
                                                            {row?.workGroupId?.numbering}. {row?.workGroupId?.work_group_name}
                                                        </TableCell>

                                                        <TableCell
                                                            className="body-cell"
                                                            sx={{ color: row?.conclusion === "completed" ? "green" : "red" }}
                                                        >
                                                            {t(`${row?.conclusion}`)}
                                                        </TableCell>

                                                        <TableCell className="body-cell-end" align="right">
                                                            <QuestoinAndAnswerAction
                                                                editData={row}
                                                                publicForumData={publicForumData}
                                                                setRefetch={refetch}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </>
                                )}
                            </>
                        )}
                    </Table>
                </TableContainer>
            </Box>
        </div>
    );
}
